import { NsAlert } from 'components/common/ns-alert/NsAlert';
import { NsCaveatLink } from 'components/common/ns-caveat-link/NsCaveatLink';
import { HELP_CONTACT_NUMBER } from 'config/app-config';

export const testId = 'bankAccountMaxAttempts422ErrorTestId';

type BankAccountMaxAttempts422ErrorProps = {
  title?: string;
};

export const BankAccountMaxAttempts422Error = ({ title }: BankAccountMaxAttempts422ErrorProps) => {

  return (
    <NsAlert state="error" heading={title} testId={testId}>
      <p>
        Call straight through to our special team of advisors on{' '}
        <b>{HELP_CONTACT_NUMBER.GENERAL_LABEL}</b> with your bank details to
        hand. They&apos;ll be happy to set up your Direct Debit over the phone,
        available Monday to Friday, 9am to 5pm.
        <NsCaveatLink>
          We&apos;re open Monday–Friday, 9am-5pm. We may record calls to help
          improve our service to you.
        </NsCaveatLink>
      </p>
    </NsAlert>
  );
};
